import type { TBrand } from "@/lib/branded";

import { z } from "zod";

import { brandString } from "@/lib/branded";

const SUPPORT_SUBSCRIBER_NEED_CODES = ["1.1", "1.2", "1.3", "1.4", "1.5", "1.6"] as const;

export type SupportSubscriberNeedCode = TBrand<
  (typeof SUPPORT_SUBSCRIBER_NEED_CODES)[number],
  "SupportSubscriberNeedCode"
>;

export const supportSubscriberNeedCodeSchema = z
  .enum(SUPPORT_SUBSCRIBER_NEED_CODES)
  .transform((code) => brandString<SupportSubscriberNeedCode>(code));

export interface SupportSubscriberNeedModel {
  code: SupportSubscriberNeedCode;
  name: string;
}
